import * as React from "react";
import { useGetBusinessVerticalsQuery } from "../services/vertical.service";
import { BusinessVertical } from "../types/vertical";
import SelectData from "./global/SelectData";

const SelectVerticals = ({
  onChange,
  values,
  label = "Industries",
  error,
  helperText,
}: {
  onChange: (ids?: number[]) => void;
  values: number[];
  label?: string;
  error?: boolean;
  helperText?: React.ReactNode;
}) => {
  const { data: verticals, isLoading } = useGetBusinessVerticalsQuery();

  return (
    <SelectData
      data={verticals}
      getOptionLabel={(vertical) => vertical.name}
      getOptionValue={(vertical) => vertical.id}
      values={values}
      onMultiChange={onChange}
      isMulti={true}
      label={label}
      placeholder="Search industries..."
      error={error}
      helperText={helperText}
      isLoading={isLoading}
    />
  );
};
export default SelectVerticals;
